import(/* webpackMode: "eager" */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/apps/scoutgame/components/common/ClientGlobals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/apps/scoutgame/components/common/ModalProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/packages/scoutgame-ui/src/providers/AppProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DraftProvider"] */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/packages/scoutgame-ui/src/providers/DraftProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatchupProvider"] */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/packages/scoutgame-ui/src/providers/MatchupProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/scoutgame.xyz/scoutgame.xyz/packages/scoutgame-ui/src/theme/styles.scss");
